<template>
  <div class="finance-page main-wrapper">
    <div class="finance-page__inner px-2 px-md-3 pt-2">
      <h3 class="finance-page__title">
        {{ $t('deposit.deposit_form') }}
      </h3>
      <div class="finance-panel">
        <van-tabs
          v-if="showTabs"
          v-model="activeTab"
          color="#0ea5e9"
          title-active-color="#0ea5e9"
          class="mb-3"
        >
          <van-tab
            v-if="depositSettings.manual"
            :title="$t('deposit.manual_deposit')"
            name="manual"
          />
          <van-tab
            v-if="depositSettings.auto"
            :title="$t('deposit.auto_deposit')"
            name="auto"
          />
        </van-tabs>

        <!-- Manual Deposit -->
        <form v-if="activeTab === 'manual' && depositSettings.manual">
          <div class="pl-lg-2">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <label
                    class="finance-label"
                    for="input-username"
                  >{{ $t('deposit.choose_payment_type') }}</label>
                  <AccountSelect
                    :data="selected_account"
                    field="account_id"
                    :accounts="accounts"
                  />
                  <span class="text-danger">{{
                    errors.account
                  }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="account.length !== 0"
              class="row mx-0"
            >
              <div class="col-12 p-0 py-3">
                <div class="finance-account-card my-2 text-center">
                  <div class="finance-account-card__head text-white">
                    {{ account[0].name }}
                  </div>
                  <div class="finance-account-card__sub text-white">
                    {{ account[0].account_name }}
                  </div>
                  <h3
                    class="finance-account-card__number"
                    id="textToCopy"
                  >
                    {{ account[0].number }}
                  </h3>
                  <button
                    type="button"
                    class="finance-copy-btn"
                    @click="copyText"
                  >
                    Copy
                  </button>
                </div>

                <p class="finance-hint mb-0 mt-2">
                  <span class="finance-hint--warn">****</span>
                  {{ account[0].note }}
                </p>
              </div>
            </div>
          </div>
          <div class="pl-lg-2">
            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label
                    class="finance-label"
                    for="deposit-amount-input"
                  >{{ $t('deposit.amount') }}</label>
                  <span class="finance-hint finance-hint--warn d-block mb-1">{{ $t('deposit.minimum_deposit') }}</span>
                  <input
                    id="deposit-amount-input"
                    type="number"
                    inputmode="numeric"
                    class="form-control finance-input"
                    v-model.number="depositData.amount"
                  >
                  <span class="text-danger">{{
                    errors.amount
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row amount-buttons-row mb-4 mx-0">
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 3000 ? 'active' : ''"
                  @click="depositCustomAmount(3000)"
                >
                  3,000 MMK
                </button>
              </div>
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 10000 ? 'active' : ''"
                  @click="depositCustomAmount(10000)"
                >
                  10,000 MMK
                </button>
              </div>
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 30000 ? 'active' : ''"
                  @click="depositCustomAmount(30000)"
                >
                  30,000 MMK
                </button>
              </div>
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 50000 ? 'active' : ''"
                  @click="depositCustomAmount(50000)"
                >
                  50,000 MMK
                </button>
              </div>
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 100000 ? 'active' : ''"
                  @click="depositCustomAmount(100000)"
                >
                  100,000 MMK
                </button>
              </div>
              <div class="col-4 amount-button-wrap">
                <button
                  type="button"
                  class="amount-chip"
                  :class="depositData.amount === 300000 ? 'active' : ''"
                  @click="depositCustomAmount(300000)"
                >
                  300,000 MMK
                </button>
              </div>
            </div>
          </div>
          <div class="col-lg-12 px-0 mt-2">
            <div class="form-group px-0">
              <label class="finance-label">{{ $store.state.language === "en" ? "Screenshot" : "ငွေပေးချေမူ ဓာက်ပုံ" }}</label>
              <div class="custom-file d-flex">
                <van-uploader
                  class="mx-auto"
                  v-model="imageUploader"
                  :max-count="1"
                />
              </div>
              <span class="text-danger">{{
                errors.image
              }}</span>
            </div>
          </div>

          <div class="pl-lg-2">
            <div class="form-group">
              <label class="finance-label">{{ $t('voucher.remark') }}</label>
              <textarea
                class="form-control finance-input finance-textarea"
                v-model="depositData.remark"
                rows="3"
              />
              <span class="text-danger">{{
                errors.remark
              }}</span>
            </div>
            <van-radio-group
              v-model="depositData.is_bonus"
              class="d-flex flex-wrap justify-content-center mb-3"
              v-if="is_promotion && $store.state.disableJson?.promotions?.is_open"
            >
              <van-radio
                class="mx-3 my-2"
                :name="false"
                checked-color="#0ea5e9"
              >{{ $store.state.language === 'en' ? 'No Bonus Point' : 'ဘောနပ် မယူပါ။' }}</van-radio>
              <van-radio
                class="mx-3 my-2"
                :name="true"
                checked-color="#0ea5e9"
              > {{ $store.state.language === 'en' ? 'Claim Bonus Point' : 'ဘောနပ် ယူမည်။' }} </van-radio>
            </van-radio-group>

            <div class="form-group mb-0">
              <button
                type="button"
                class="btn finance-btn-primary"
                @click="sendDepositData"
              >
                <div v-if="!isConfirm">
                  {{ $t('deposit.submit') }}
                </div>

                <Loading
                  color="#ffffff"
                  v-if="isConfirm"
                  size="24"
                  class="px-4 py-0"
                />
              </button>
            </div>
          </div>
        </form>

        <!-- Auto Deposit -->
        <form v-if="activeTab === 'auto' && depositSettings.auto">
          <div class="pl-lg-2">
            <p class="finance-hint">{{ $t('deposit.auto_deposit_hint') }}</p>
            <p v-if="hasPendingAutoDeposit" class="text-info mb-3">
              {{ $t('deposit.pending_auto_hint') }}
            </p>
            <p v-if="!hasEnabledPaymentChannel" class="text-danger">
              {{ $store.state.language === 'en'
                ? 'All auto payment channels are temporarily unavailable. Please try manual deposit or check back later.'
                : 'အလိုအလျောက် ငွေသွင်းနည်းလမ်းအားလုံး ယာယီမရရှိနိုင်ပါ။ လက်ဖြင့် ငွေသွင်းခြင်း သို့မဟုတ် နောက်မှ ထပ်စမ်းကြည့်ပါ။' }}
            </p>
            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label class="finance-label">{{ $t('deposit.choose_bank') }}</label>
                  <select
                    v-model="autoDepositData.bank"
                    class="form-control finance-input"
                    :disabled="!hasEnabledPaymentChannel"
                  >
                    <option
                      v-for="bank in enabledPaymentBanks"
                      :key="bank.code"
                      :value="bank.code"
                    >
                      {{ bank.name }}
                    </option>
                  </select>
                  <span class="text-danger">{{ errors.bank }}</span>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-group">
                  <label class="finance-label">{{ $t('deposit.amount') }}</label>
                  <span class="finance-hint finance-hint--warn d-block mb-1">{{ $t('deposit.minimum_auto_deposit') }}</span>
                  <input
                    type="number"
                    inputmode="numeric"
                    class="form-control finance-input"
                    v-model.number="autoDepositData.amount"
                  >
                  <span class="text-danger">{{ errors.amount }}</span>
                </div>
                <div class="row amount-buttons-row mb-4 mx-0">
                  <div
                    v-for="preset in amountPresets"
                    :key="'auto-' + preset"
                    class="col-4 amount-button-wrap"
                  >
                    <button
                      type="button"
                      class="amount-chip"
                      :class="autoDepositData.amount === preset ? 'active' : ''"
                      @click="autoDepositData.amount = preset"
                    >
                      {{ preset.toLocaleString() }} MMK
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="finance-label">{{ $t('voucher.remark') }}</label>
              <textarea
                class="form-control finance-input finance-textarea"
                v-model="autoDepositData.remark"
                rows="3"
              />
            </div>

            <div v-if="autoPayment.qrcode" class="text-center my-4">
              <p class="finance-label">{{ $t('deposit.scan_qr') }}</p>
              <img :src="autoPayment.qrcode" alt="QR Code" class="qr-image" />
            </div>

            <div class="form-group mb-0">
              <button
                type="button"
                class="btn finance-btn-primary"
                @click="sendAutoDeposit"
                :disabled="isConfirm || !hasEnabledPaymentChannel"
              >
                <div v-if="!isConfirm">{{ autoPayment.payment_url ? $t('deposit.open_payment') : $t('deposit.submit') }}</div>
                <Loading color="#ffffff" v-if="isConfirm" size="24" class="px-4 py-0" />
              </button>
            </div>

            <div v-if="requiresUtr && autoPayment.out_trade_no" class="mt-3">
              <div class="form-group">
                <label class="finance-label">{{ $t('deposit.utr_label') }}</label>
                <input
                  type="text"
                  class="form-control finance-input"
                  v-model="autoDepositData.utr"
                  :placeholder="$t('deposit.utr_placeholder')"
                >
                <span class="text-danger">{{ errors.utr }}</span>
              </div>
              <div class="form-group">
                <button
                  type="button"
                  class="btn finance-btn-primary"
                  @click="submitAutoDepositUtr"
                  :disabled="isConfirm"
                >
                  <div v-if="!isConfirm">{{ $t('deposit.submit_utr') }}</div>
                  <Loading color="#ffffff" v-if="isConfirm" size="24" class="px-4 py-0" />
                </button>
              </div>
            </div>

            <div v-if="autoPayment.out_trade_no && isPolling" class="text-center mt-2 deposit-pending-actions">
              <p class="finance-hint mb-2">{{ $t('deposit.waiting_payment') }}</p>
              <button
                v-if="autoPayment.payment_url && !showPaymentWebView"
                type="button"
                class="btn btn-sm btn-dark mb-2"
                @click="openPaymentWebView(autoPayment.payment_url)"
              >
                {{ $t('deposit.open_payment') }}
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                @click="cancelPendingDeposit"
              >
                {{ $t('deposit.cancel_deposit') }}
              </button>
            </div>
          </div>
        </form>

        <div v-if="!depositSettings.manual && !depositSettings.auto" class="text-center py-5 text-muted">
          {{ $t('deposit.disabled') }}
        </div>
      </div>
    </div>

    <!-- In-app payment page from payment server -->
    <div v-if="showPaymentWebView && paymentWebViewUrl" class="payment-webview-overlay">
      <div class="payment-webview-header">
        <span class="payment-webview-title">{{ $t('deposit.payment_page_title') }}</span>
        <button
          type="button"
          class="btn btn-sm btn-outline-light payment-webview-cancel"
          @click="cancelPendingDeposit"
        >
          {{ $t('deposit.cancel_deposit') }}
        </button>
      </div>
      <iframe
        :src="paymentWebViewUrl"
        class="payment-webview-frame"
        title="Payment"
        referrerpolicy="no-referrer-when-downgrade"
      />
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';
import AccountSelect from './components/AccountSelect.vue';
import {
  PAYMENT_BANK_OPTIONS,
  DEFAULT_PAYMENT_CODE,
  resolvePaymentCode,
} from '../../constants/banks';

export default {
  components: { AccountSelect, Loading },
  data() {
    return {
      activeTab: 'manual',
      depositSettings: { manual: true, auto: true, auto_provider: 'tianci', kbz: true, wave: true },
      selected_account: {},
      accounts: [],
      account: [],
      imageUploader: [],
      depositData: {
        is_bonus: false,
        amount: 0,
      },
      autoDepositData: { bank: DEFAULT_PAYMENT_CODE, amount: null, remark: '', utr: '' },
      autoPayment: {},
      is_promotion: true,
      errors: {},
      isConfirm: false,
      isPolling: false,
      pollTimer: null,
      showPaymentWebView: false,
      paymentWebViewUrl: null,
      testing: 0,
      amountPresets: [3000, 5000, 10000, 30000, 50000, 100000],
      restoringPending: false,
    };
  },
  computed: {
    showTabs() {
      return this.depositSettings.manual && this.depositSettings.auto;
    },
    requiresUtr() {
      return this.depositSettings.auto_provider === 'sgpay'
        || this.autoPayment.requires_utr === true;
    },
    enabledPaymentBanks() {
      return PAYMENT_BANK_OPTIONS.filter((bank) => {
        if (bank.code.includes('kbz')) {
          return this.depositSettings.kbz !== false;
        }
        if (bank.code.includes('wave')) {
          return this.depositSettings.wave !== false;
        }
        return true;
      });
    },
    hasEnabledPaymentChannel() {
      return this.enabledPaymentBanks.length > 0;
    },
    hasPendingAutoDeposit() {
      return Boolean(this.autoPayment.out_trade_no && this.autoPayment.status === 'pending');
    },
    currentTime() {
      return moment(this.createDateWithTimeZone()).format('lll');
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    handlePaymentReturnFromGateway() {
      const query = this.$route.query;
      if (query.tab === 'auto' && this.depositSettings.auto) {
        this.activeTab = 'auto';
      }

      const orderNo =
        query.out_trade_no ||
        query.order_no ||
        sessionStorage.getItem('pending_auto_deposit_order');

      if (!orderNo) {
        return;
      }

      if (this.depositSettings.auto) {
        this.activeTab = 'auto';
      }

      this.autoPayment = { ...this.autoPayment, out_trade_no: orderNo };
      this.startPolling(orderNo);

      if (query.payment_return || query.out_trade_no || query.order_no) {
        this.$router.replace({ path: '/deposit', query: { tab: 'auto' } }).catch(() => {});
      }
    },
    clearAutoPaymentSession(clearPolling = true) {
      this.closePaymentWebView();
      if (clearPolling) {
        this.clearPolling();
        this.isPolling = false;
      }
      this.autoPayment = {};
    },
    openPaymentWebView(url) {
      if (!url) {
        return;
      }
      this.paymentWebViewUrl = url;
      this.showPaymentWebView = true;
    },
    closePaymentWebView() {
      this.showPaymentWebView = false;
      this.paymentWebViewUrl = null;
    },
    resetAutoDepositForm() {
      const bank = this.autoDepositData.bank || DEFAULT_PAYMENT_CODE;
      this.autoDepositData = {
        bank,
        amount: null,
        remark: '',
        utr: '',
      };
    },
    async cancelPendingDeposit() {
      const orderNo = this.autoPayment.out_trade_no;
      try {
        await Dialog.confirm({
          title: this.$t('deposit.cancel_deposit'),
          message: this.$t('deposit.cancel_deposit_confirm'),
          cancelButtonText: this.$store.state.language === 'en' ? 'No' : 'မလုပ်တော့ပါ',
          confirmButtonText: this.$store.state.language === 'en' ? 'Yes, cancel' : 'ပယ်ဖျက်မည်',
          className: 'deposit-cancel-dialog',
          overlayClass: 'deposit-cancel-dialog-overlay',
          overlayStyle: { zIndex: 10100 },
        });
      } catch (error) {
        return;
      }

      try {
        if (orderNo) {
          await axios.post(
            '/auto-deposits/cancel',
            { order_no: orderNo },
            { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
          );
        }
      } catch (error) {
        console.log(error);
      }

      this.clearPendingAutoDepositOrder();
      this.clearAutoPaymentSession();
      this.resetAutoDepositForm();
      Toast.success(this.$t('deposit.deposit_cancelled'));
    },
    rememberPendingAutoDepositOrder(outTradeNo) {
      if (outTradeNo) {
        sessionStorage.setItem('pending_auto_deposit_order', outTradeNo);
      }
    },
    clearPendingAutoDepositOrder() {
      sessionStorage.removeItem('pending_auto_deposit_order');
    },
    depositCustomAmount(number) {
      const n = Number(number);
      this.depositData.amount = n;
    },
    copyText() {
      const textToCopy = document.getElementById('textToCopy').innerText;
      const textarea = document.createElement('textarea');
      textarea.value = textToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      alert('You have copy Phone Number');
    },
    applyPaymentChannelDefaults() {
      const enabled = this.enabledPaymentBanks;
      if (!enabled.some((bank) => bank.code === this.autoDepositData.bank)) {
        if (enabled.length) {
          this.autoDepositData.bank = enabled[0].code;
          if (!this.hasPendingAutoDeposit) {
            this.clearAutoPaymentSession();
          }
        }
      }
    },
    restorePendingAutoDeposit(pending) {
      if (!pending?.out_trade_no) {
        return;
      }

      this.restoringPending = true;

      if (this.depositSettings.auto) {
        this.activeTab = 'auto';
      }

      this.autoDepositData = {
        bank: resolvePaymentCode(pending.bank),
        amount: pending.amount,
        remark: this.autoDepositData.remark || '',
        utr: pending.utr || this.autoDepositData.utr || '',
      };
      this.autoPayment = {
        ...pending,
        bank: resolvePaymentCode(pending.bank),
        amount: pending.amount,
        requires_utr: pending.requires_utr
          ?? this.depositSettings.auto_provider === 'sgpay',
      };
      this.rememberPendingAutoDepositOrder(pending.out_trade_no);
      this.startPolling(pending.out_trade_no);
      this.restoringPending = false;
    },
    async fetchPendingAutoDeposit() {
      try {
        const res = await axios.get('/auto-deposits/pending', {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        this.restorePendingAutoDeposit(res.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    async fetchDepositSettings() {
      try {
        const res = await axios.get('/deposit-settings');
        this.depositSettings = res.data.data;
        this.applyPaymentChannelDefaults();
        if (this.depositSettings.manual) {
          this.activeTab = 'manual';
        } else if (this.depositSettings.auto) {
          this.activeTab = 'auto';
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAccounts() {
      try {
        const res = await axios.get('/accounts', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.accounts = res.data.data;
        this.is_promotion = res.data.is_promotion;
      } catch (error) {
        console.log(error);
      }
    },
    validateAmount(amount) {
      if (!amount) {
        this.errors.amount = this.$t('deposit.enter_amount');
        return false;
      }
      if (amount < 2000) {
        this.errors.amount = this.$t('deposit.enter_at_least');
        return false;
      }
      return true;
    },
    async sendDepositData() {
      try {
        const authUser = await this.fetchUser();
        this.errors = {};
        if (!this.selected_account.account_id) {
          this.errors.account = this.$store.state.language === 'en'
            ? 'Please pick account type'
            : 'အကောင့်အမျိုးအစား ရွေးချယ်ပေးပါ။';
          return false;
        }
        if (!this.imageUploader.length > 0) {
          this.errors.image = this.$store.state.language === 'en'
            ? 'Please insert screenshot photo'
            : 'ငွေပေးချေမူမှတ်တမ်း (screenshot) ထည့်သွင်းပါ။';
          return false;
        }

        if (!this.depositData.amount) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter amount'
            : 'ငွေပမာဏထည့်ပေးပါ။';
          return false;
        }
        if (this.depositData.amount < 3000) {
          this.errors.amount = this.$store.state.language === 'en'
            ? 'Please enter at least 3,000 MMK'
            : 'ငွေပမာဏအနည်းဆုံး ၃,၀၀၀ ထည့်ပေးပါ။';
          return false;
        }
        this.isConfirm = true;
        if (this.imageUploader[0]) {
          this.depositData.transaction_image = await this.compressAndConvertToWebP(this.imageUploader[0].content);
        }
        this.depositData.account_id = this.account[0].id;
        this.depositData.date = this.currentTime;
        await axios.post('/deposits', this.depositData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        this.imageUploader = [];
        this.depositData = { is_bonus: false, amount: 0 };
        this.selected_account.account_id = null;
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success'
            : 'အောင်မြင်သည်။',
        );
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
        this.showDepositError(error);
      }
      return true;
    },
    async submitAutoDepositUtr() {
      try {
        this.errors = {};
        if (!this.autoPayment.out_trade_no) {
          return;
        }
        if (!this.autoDepositData.utr) {
          this.errors.utr = this.$t('deposit.enter_utr');
          return;
        }

        this.isConfirm = true;
        const res = await axios.post('/auto-deposits/utr', {
          order_no: this.autoPayment.out_trade_no,
          utr: this.autoDepositData.utr,
        }, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });

        if (res.data.data.return_url) {
          this.openPaymentWebView(res.data.data.return_url);
        }

        this.startPolling(this.autoPayment.out_trade_no);
        Toast.success(this.$t('deposit.utr_submitted'));
        this.isConfirm = false;
      } catch (error) {
        this.isConfirm = false;
        this.showDepositError(error);
      }
    },
    async sendAutoDeposit() {
      try {
        this.errors = {};
        await this.fetchUser();

        if (!this.autoDepositData.bank) {
          this.errors.bank = this.$t('deposit.choose_bank');
          return;
        }
        if (!this.validateAmount(this.autoDepositData.amount)) return;

        if (this.autoPayment.payment_url && this.autoPayment.out_trade_no) {
          this.openPaymentWebView(this.autoPayment.payment_url);
          if (!this.isPolling) {
            this.startPolling(this.autoPayment.out_trade_no);
          }
          return;
        }

        this.clearAutoPaymentSession(false);
        this.isConfirm = true;
        const res = await axios.post(
          '/auto-deposits',
          this.autoDepositData,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          },
        );

        const payment = res.data.data;
        const bank = resolvePaymentCode(payment.bank) || this.autoDepositData.bank;
        this.restoringPending = true;
        this.autoDepositData.bank = bank;
        this.autoDepositData.amount = payment.amount;
        this.restoringPending = false;
        this.autoPayment = {
          ...payment,
          bank,
          amount: payment.amount,
          requires_utr: payment.requires_utr
            ?? this.depositSettings.auto_provider === 'sgpay',
        };
        this.rememberPendingAutoDepositOrder(this.autoPayment.out_trade_no);
        this.isConfirm = false;

        if (this.autoPayment.payment_url) {
          this.openPaymentWebView(this.autoPayment.payment_url);
          this.startPolling(this.autoPayment.out_trade_no);
        } else if (this.autoPayment.qrcode) {
          this.startPolling(this.autoPayment.out_trade_no);
        } else {
          Toast.fail(this.$t('deposit.payment_unavailable'));
        }
      } catch (error) {
        this.isConfirm = false;
        this.showDepositError(error);
      }
    },
    startPolling(outTradeNo) {
      this.isPolling = true;
      this.clearPolling();
      this.pollTimer = setInterval(() => this.checkAutoDepositStatus(outTradeNo), 5000);
      this.checkAutoDepositStatus(outTradeNo);
    },
    clearPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async checkAutoDepositStatus(outTradeNo) {
      try {
        const res = await axios.get(`/auto-deposits/${outTradeNo}/status`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        const data = res.data.data;
        const { status } = data;
        if (data.payment_url) {
          this.autoPayment = {
            ...this.autoPayment,
            payment_url: data.payment_url,
            return_url: data.return_url,
          };
        }
        if (status === 'confirm') {
          this.clearPolling();
          this.isPolling = false;
          this.clearPendingAutoDepositOrder();
          this.closePaymentWebView();
          this.autoPayment = {};
          this.resetAutoDepositForm();
          await this.fetchUser();
          Toast.success(this.$t('deposit.auto_success'));
        } else if (status === 'fail') {
          this.clearPolling();
          this.isPolling = false;
          this.clearPendingAutoDepositOrder();
          this.closePaymentWebView();
          Toast.fail(this.$t('deposit.auto_failed'));
        }
      } catch (error) {
        console.log(error);
      }
    },
    showDepositError(error) {
      let errorMessage = 'ငွေသွင်း၍ မရသေးပါ။ Customer service သို့ဆက်သွယ်ပေးပါ။';
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      Dialog.alert({
        message: errorMessage,
        confirmButtonText: this.$store.state.language === 'en' ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
      });
    },
    createDateWithTimeZone() {
      const moment = require('moment-timezone');
      const dateInTimeZone = moment.tz(new Date(), 'Asia/Rangoon');
      const year = dateInTimeZone.year();
      const month = dateInTimeZone.month();
      const day = dateInTimeZone.date();
      const hour = dateInTimeZone.hour();
      const minute = dateInTimeZone.minute();
      const second = dateInTimeZone.second();
      const millisecond = dateInTimeZone.millisecond();
      return new Date(year, month, day, hour, minute, second, millisecond);
    },
    compressAndConvertToWebP(dataUrl, quality = 0.7, maxWidth = 1280) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          const webpDataUrl = canvas.toDataURL('image/webp', quality);
          resolve(webpDataUrl);
        };
        img.onerror = (err) => reject(err);
        img.src = dataUrl;
      });
    },
  },
  watch: {
    'selected_account.account_id': function () {
      this.account = this.accounts.filter(
        (account) => account.id === this.selected_account.account_id,
      );
    },
    activeTab(tab) {
      this.errors = {};
      if (tab !== 'auto') {
        this.clearAutoPaymentSession();
        return;
      }
      if (!this.autoPayment.payment_url) {
        this.fetchPendingAutoDeposit();
      }
    },
    'autoDepositData.bank'() {
      if (this.restoringPending) {
        return;
      }
      this.clearAutoPaymentSession();
    },
    'autoDepositData.amount'() {
      if (this.restoringPending) {
        return;
      }
      if (this.autoPayment.out_trade_no) {
        this.clearAutoPaymentSession();
      }
    },
  },
  async mounted() {
    await this.fetchDepositSettings();
    this.fetchAccounts();
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
      return;
    }
    this.handlePaymentReturnFromGateway();
    if (!this.autoPayment.payment_url) {
      await this.fetchPendingAutoDeposit();
    }
  },
  beforeDestroy() {
    this.clearPolling();
    this.closePaymentWebView();
  },
};
</script>
<style scoped>
.image-container {
  width: 200px;
  height: 200px;
}

.image-container img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

.number-container {
  border-radius: 5px;
  justify-content: center;
}

.custom-file {
  height: auto;
}

.amount-cont.active {
  background: #dee2e6;
  color: black !important;
  border: 1px solid;
}

.qr-image {
  max-width: 240px;
  width: 100%;
  border-radius: 8px;
}

.deposit-pending-actions {
  padding-bottom: 1rem;
}

.payment-webview-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.payment-webview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  background: #111;
  color: #fff;
  flex-shrink: 0;
}

.payment-webview-title {
  font-size: 0.95rem;
  font-weight: 600;
}

.payment-webview-cancel {
  white-space: nowrap;
}

.payment-webview-frame {
  flex: 1;
  width: 100%;
  border: none;
  background: #fff;
}
</style>

<!-- Vant Dialog is mounted on body; must exceed payment webview z-index (10050) -->
<style>
.deposit-cancel-dialog-overlay {
  z-index: 10100 !important;
}

.deposit-cancel-dialog {
  z-index: 10101 !important;
}
</style>
